<template>
  <base-section
    id="nos-revendeurs"
    class="secondary"
  >
    <base-section-heading
      class="white--text"
      title="Où acheter nos produits ?"
    >
    </base-section-heading>
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="revendeur in revendeurs"
            :key="revendeurs.nom"
            cols="12"
            sm="6"
            md="6"
            lg="6"
          >
            <v-card
              height="100%"
              style="padding:10px;"
              class="mx-auto"
            >
              <v-list-item-title class="headline mb-1 text-center">{{revendeur.nom}}</v-list-item-title>

              <v-card-text class="text--primary" style="font-family: Arial;">
                <div><p v-html="revendeur.adresse"></p></div>
                <div><p>Tel : {{revendeur.tel}}</p></div>
                <div v-if="revendeur.email !== ''"><p>Email : {{revendeur.email}}</p></div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionNosRevendeurs',

    methods : {
      getImage(p){
        return ""
      }
    },
    data: () => ({
      revendeurs: [
        {
          nom: 'Pronewtec SARL',
          adresse: '3 Impasse Champs au Roi <br> 90100 Saint Dizier L\'Evèque',
          tel:"06 07 71 79 74 / 06 89 66 49 05",
          email:"pronewtec@yahoo.fr",
        },
        {
          nom: 'Le Clos des Oliviers',
          adresse: 'Giamarchi Michèle et José <br> Hameau de Querciolo <br> 20213 Sorbo-Ocagnano',
          tel:"06 18 61 71 99",
          email:"leclosdesoliviers@laposte.net",
        },
      ],
    }),
  }
</script>
